<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2 class="font-bold">宁向进气</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <div class="legend-right">
          <div class="running">排水阀打开</div>
          <div class="stopped">排水阀关闭</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor2 sensor-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJN1, drainAJN1) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJN1, drainBJN1) }}
              </div>
              <div :class="errorJN1" class="state-info right-pos">
                <p>JN1气夹</p>
                <p>
                  <span>阀门关度: {{ valveJN1 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJN1" class="valve-sign"></span> <span :class="drainBClassJN1" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-left-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJN3, drainAJN3) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJN3, drainBJN3) }}
              </div>
              <div :class="errorJN3" class="state-info right-pos">
                <p>JN3气夹</p>
                <p>
                  <span>阀门关度: {{ valveJN3 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJN3" class="valve-sign"></span> <span :class="drainBClassJN3" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJNM5, drainAJNM5) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJNM5, drainBJNM5) }}
              </div>
              <div :class="errorJNM5" class="state-info left-pos">
                <p>JNM5气夹</p>
                <p>
                  <span>阀门关度: {{ valveJNM5 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJNM5" class="valve-sign"></span> <span :class="drainBClassJNM5" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJNM3, drainAJNM3) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJNM3, drainBJNM3) }}
              </div>
              <div :class="errorJNM3" class="state-info left-pos">
                <p>JNM3气夹</p>
                <p>
                  <span>阀门关度: {{ valveJNM3 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJNM3" class="valve-sign"></span> <span :class="drainBClassJNM3" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJNM1, drainAJNM1) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJNM1, drainBJNM1) }}
              </div>
              <div :class="errorJNM1" class="state-info right-pos">
                <p>JNM1气夹</p>
                <p>
                  <span>阀门关度: {{ valveJNM1 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJNM1" class="valve-sign"></span> <span :class="drainBClassJNM1" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJNM1Plus, drainAJNM1Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJNM1Plus, drainBJNM1Plus) }}
              </div>
              <div :class="errorJNM1Plus" class="state-info left-pos">
                <p>JNM1+气夹</p>
                <p>
                  <span>阀门关度: {{ valveJNM1Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJNM1Plus" class="valve-sign"></span> <span :class="drainBClassJNM1Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJNM3Plus, drainAJNM3Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJNM3Plus, drainBJNM3Plus) }}
              </div>
              <div :class="errorJNM3Plus" class="state-info right-pos">
                <p>JNM3+气夹</p>
                <p>
                  <span>阀门关度: {{ valveJNM3Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJNM3Plus" class="valve-sign"></span> <span :class="drainBClassJNM3Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-middle-12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJNM5Plus, drainAJNM5Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJNM5Plus, drainBJNM5Plus) }}
              </div>
              <div :class="errorJNM5Plus" class="state-info right-pos">
                <p>JNM5+气夹</p>
                <p>
                  <span>阀门关度: {{ valveJNM5Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJNM5Plus" class="valve-sign"></span> <span :class="drainBClassJNM5Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-right-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJN3Plus, drainAJN3Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJN3Plus, drainBJN3Plus) }}
              </div>
              <div :class="errorJN3Plus" class="state-info left-pos">
                <p>JN3+气夹</p>
                <p>
                  <span>阀门关度: {{ valveJN3Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJN3Plus" class="valve-sign"></span> <span :class="drainBClassJN3Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 sensor-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAJN1Plus, drainAJN1Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBJN1Plus, drainBJN1Plus) }}
              </div>
              <div :class="errorJN1Plus" class="state-info left-pos">
                <p>JN1+气夹</p>
                <p>
                  <span>阀门关度: {{ valveJN1Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassJN1Plus" class="valve-sign"></span> <span :class="drainBClassJN1Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>宁向排气</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div>
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <div class="legend-right">
          <div class="running">排水阀打开</div>
          <div class="stopped">排水阀关闭</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-left-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPN0, drainAPN0) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPN0, drainBPN0) }}
              </div>
              <div :class="errorPN0" class="state-info right-pos">
                <p>PN0气夹</p>
                <p>
                  <span>阀门关度: {{ valvePN0 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPN0" class="valve-sign"></span> <span :class="drainBClassPN0" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-left-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPN2, drainAPN2) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPN2, drainBPN2) }}
              </div>
              <div :class="errorPN2" class="state-info right-pos">
                <p>PN2气夹</p>
                <p>
                  <span>阀门关度: {{ valvePN2 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPN2" class="valve-sign"></span> <span :class="drainBClassPN2" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-left-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPN4, drainAPN4) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPN4, drainBPN4) }}
              </div>
              <div :class="errorPN4" class="state-info right-pos">
                <p>PN4气夹</p>
                <p>
                  <span>阀门关度: {{ valvePN4 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPN4" class="valve-sign"></span> <span :class="drainBClassPN4" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPNM6, drainAPNM6) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPNM6, drainBPNM6) }}
              </div>
              <div :class="errorPNM6" class="state-info left-pos">
                <p>PNM6气夹</p>
                <p>
                  <span>阀门关度: {{ valvePNM6 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPNM6" class="valve-sign"></span> <span :class="drainBClassPNM6" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPNM4, drainAPNM4) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPNM4, drainBPNM4) }}
              </div>
              <div :class="errorPNM4" class="state-info left-pos">
                <p>PNM4气夹</p>
                <p>
                  <span>阀门关度: {{ valvePNM4 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPNM4" class="valve-sign"></span> <span :class="drainBClassPNM4" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPNM2, drainAPNM2) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPNM2, drainBPNM2) }}
              </div>
              <div :class="errorPNM2" class="state-info right-pos">
                <p>PNM2气夹</p>
                <p>
                  <span>阀门关度: {{ valvePNM2 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPNM2" class="valve-sign"></span> <span :class="drainBClassPNM2" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPNM0, drainAPNM0) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPNM0, drainBPNM0) }}
              </div>
              <div :class="errorPNM0" class="state-info top-pos">
                <p>PNM0气夹</p>
                <p>
                  <span>阀门关度: {{ valvePNM0 | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPNM0" class="valve-sign"></span> <span :class="drainBClassPNM0" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPNM2Plus, drainAPNM2Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPNM2Plus, drainBPNM2Plus) }}
              </div>
              <div :class="errorPNM2Plus" class="state-info left-pos">
                <p>PNM2+气夹</p>
                <p>
                  <span>阀门关度: {{ valvePNM2Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPNM2Plus" class="valve-sign"></span> <span :class="drainBClassPNM2Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPNM4Plus, drainAPNM4Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPNM4Plus, drainBPNM4Plus) }}
              </div>
              <div :class="errorPNM4Plus" class="state-info right-pos">
                <p>PNM4+气夹</p>
                <p>
                  <span>阀门关度: {{ valvePNM4Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPNM4Plus" class="valve-sign"></span> <span :class="drainBClassPNM4Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPNM6Plus, drainAPNM6Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPNM6Plus, drainBPNM6Plus) }}
              </div>
              <div :class="errorPNM6Plus" class="state-info right-pos">
                <p>PNM6+气夹</p>
                <p>
                  <span>阀门关度: {{ valvePNM6Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPNM6Plus" class="valve-sign"></span> <span :class="drainBClassPNM6Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPN4Plus, drainAPN4Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPN4Plus, drainBPN4Plus) }}
              </div>
              <div :class="errorPN4Plus" class="state-info left-pos">
                <p>PN4+气夹</p>
                <p>
                  <span>阀门关度: {{ valvePN4Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPN4Plus" class="valve-sign"></span> <span :class="drainBClassPN4Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPN2Plus, drainAPN2Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPN2Plus, drainBPN2Plus) }}
              </div>
              <div :class="errorPN2Plus" class="state-info left-pos">
                <p>PN2+气夹</p>
                <p>
                  <span>阀门关度: {{ valvePN2Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPN2Plus" class="valve-sign"></span> <span :class="drainBClassPN2Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_drain("排水阀1", errorDrainAPN0Plus, drainAPN0Plus) }} <br />
                {{ assembleTooltip_drain("排水阀2", errorDrainBPN0Plus, drainBPN0Plus) }}
              </div>
              <div :class="errorPN0Plus" class="state-info left-pos">
                <p>PN0+气夹</p>
                <p>
                  <span>阀门关度: {{ valvePN0Plus | toFixed }}% </span>
                </p>
                <p class="drain-container">
                  排水阀: <span :class="drainAClassPN0Plus" class="valve-sign"></span> <span :class="drainBClassPN0Plus" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
        
        <script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      routerPrefix: "xihoumenSensor",
      bridgeId: "3aeeb5b1-f586-43c4-b03c-2e5880d2e541",

      //valve drain
      valvePZ0: "--",
      valvePN0: "--",
      valveJZ1: "--",
      valveJN1: "--",
      valvePZ2: "--",
      valvePN2: "--",
      valveJZ3: "--",
      valveJN3: "--",
      valvePZ4: "--",
      valvePN4: "--",
      valvePZM6: "--",
      valvePNM6: "--",
      valveJZM5: "--",
      valveJNM5: "--",
      valvePZM4: "--",
      valvePNM4: "--",
      valveJZM3: "--",
      valveJNM3: "--",
      valvePZM2: "--",
      valvePNM2: "--",
      valveJZM1: "--",
      valveJNM1: "--",
      valvePZM0: "--",
      valvePNM0: "--",
      valvePZ0Plus: "--",
      valvePN0Plus: "--",
      valveJZ1Plus: "--",
      valveJN1Plus: "--",
      valvePZ2Plus: "--",
      valvePN2Plus: "--",
      valveJZ3Plus: "--",
      valveJN3Plus: "--",
      valvePZ4Plus: "--",
      valvePN4Plus: "--",
      valvePZM6Plus: "--",
      valvePNM6Plus: "--",
      valveJZM5Plus: "--",
      valveJNM5Plus: "--",
      valvePZM4Plus: "--",
      valvePNM4Plus: "--",
      valveJZM3Plus: "--",
      valveJNM3Plus: "--",
      valvePZM2Plus: "--",
      valvePNM2Plus: "--",
      valveJZM1Plus: "--",
      valveJNM1Plus: "--",

      drainAPZ0: "--",
      drainAPN0: "--",
      drainAJZ1: "--",
      drainAJN1: "--",
      drainAPZ2: "--",
      drainAPN2: "--",
      drainAJZ3: "--",
      drainAJN3: "--",
      drainAPZ4: "--",
      drainAPN4: "--",
      drainAPZM6: "--",
      drainAPNM6: "--",
      drainAJZM5: "--",
      drainAJNM5: "--",
      drainAPZM4: "--",
      drainAPNM4: "--",
      drainAJZM3: "--",
      drainAJNM3: "--",
      drainAPZM2: "--",
      drainAPNM2: "--",
      drainAJZM1: "--",
      drainAJNM1: "--",
      drainAPZM0: "--",
      drainAPNM0: "--",
      drainAPZ0Plus: "--",
      drainAPN0Plus: "--",
      drainAJZ1Plus: "--",
      drainAJN1Plus: "--",
      drainAPZ2Plus: "--",
      drainAPN2Plus: "--",
      drainAJZ3Plus: "--",
      drainAJN3Plus: "--",
      drainAPZ4Plus: "--",
      drainAPN4Plus: "--",
      drainAPZM6Plus: "--",
      drainAPNM6Plus: "--",
      drainAJZM5Plus: "--",
      drainAJNM5Plus: "--",
      drainAPZM4Plus: "--",
      drainAPNM4Plus: "--",
      drainAJZM3Plus: "--",
      drainAJNM3Plus: "--",
      drainAPZM2Plus: "--",
      drainAPNM2Plus: "--",
      drainAJZM1Plus: "--",
      drainAJNM1Plus: "--",

      drainBPZ0: "--",
      drainBPN0: "--",
      drainBJZ1: "--",
      drainBJN1: "--",
      drainBPZ2: "--",
      drainBPN2: "--",
      drainBJZ3: "--",
      drainBJN3: "--",
      drainBPZ4: "--",
      drainBPN4: "--",
      drainBPZM6: "--",
      drainBPNM6: "--",
      drainBJZM5: "--",
      drainBJNM5: "--",
      drainBPZM4: "--",
      drainBPNM4: "--",
      drainBJZM3: "--",
      drainBJNM3: "--",
      drainBPZM2: "--",
      drainBPNM2: "--",
      drainBJZM1: "--",
      drainBJNM1: "--",
      drainBPZM0: "--",
      drainBPNM0: "--",
      drainBPZ0Plus: "--",
      drainBPN0Plus: "--",
      drainBJZ1Plus: "--",
      drainBJN1Plus: "--",
      drainBPZ2Plus: "--",
      drainBPN2Plus: "--",
      drainBJZ3Plus: "--",
      drainBJN3Plus: "--",
      drainBPZ4Plus: "--",
      drainBPN4Plus: "--",
      drainBPZM6Plus: "--",
      drainBPNM6Plus: "--",
      drainBJZM5Plus: "--",
      drainBJNM5Plus: "--",
      drainBPZM4Plus: "--",
      drainBPNM4Plus: "--",
      drainBJZM3Plus: "--",
      drainBJNM3Plus: "--",
      drainBPZM2Plus: "--",
      drainBPNM2Plus: "--",
      drainBJZM1Plus: "--",
      drainBJNM1Plus: "--",

      //error
      errorPZ0: "--",
      errorPN0: "--",
      errorJZ1: "--",
      errorJN1: "--",
      errorPZ2: "--",
      errorPN2: "--",
      errorJZ3: "--",
      errorJN3: "--",
      errorPZ4: "--",
      errorPN4: "--",
      errorPZM6: "--",
      errorPNM6: "--",
      errorJZM5: "--",
      errorJNM5: "--",
      errorPZM4: "--",
      errorPNM4: "--",
      errorJZM3: "--",
      errorJNM3: "--",
      errorPZM2: "--",
      errorPNM2: "--",
      errorJZM1: "--",
      errorJNM1: "--",
      errorPZM0: "--",
      errorPNM0: "--",
      errorPZ0Plus: "--",
      errorPN0Plus: "--",
      errorJZ1Plus: "--",
      errorJN1Plus: "--",
      errorPZ2Plus: "--",
      errorPN2Plus: "--",
      errorJZ3Plus: "--",
      errorJN3Plus: "--",
      errorPZ4Plus: "--",
      errorPN4Plus: "--",
      errorPZM6Plus: "--",
      errorPNM6Plus: "--",
      errorJZM5Plus: "--",
      errorJNM5Plus: "--",
      errorPZM4Plus: "--",
      errorPNM4Plus: "--",
      errorJZM3Plus: "--",
      errorJNM3Plus: "--",
      errorPZM2Plus: "--",
      errorPNM2Plus: "--",
      errorJZM1Plus: "--",
      errorJNM1Plus: "--",

      errorDrainAPZ0: "--",
      errorDrainAPN0: "--",
      errorDrainAJZ1: "--",
      errorDrainAJN1: "--",
      errorDrainAPZ2: "--",
      errorDrainAPN2: "--",
      errorDrainAJZ3: "--",
      errorDrainAJN3: "--",
      errorDrainAPZ4: "--",
      errorDrainAPN4: "--",
      errorDrainAPZM6: "--",
      errorDrainAPNM6: "--",
      errorDrainAJZM5: "--",
      errorDrainAJNM5: "--",
      errorDrainAPZM4: "--",
      errorDrainAPNM4: "--",
      errorDrainAJZM3: "--",
      errorDrainAJNM3: "--",
      errorDrainAPZM2: "--",
      errorDrainAPNM2: "--",
      errorDrainAJZM1: "--",
      errorDrainAJNM1: "--",
      errorDrainAPZM0: "--",
      errorDrainAPNM0: "--",
      errorDrainAPZ0Plus: "--",
      errorDrainAPN0Plus: "--",
      errorDrainAJZ1Plus: "--",
      errorDrainAJN1Plus: "--",
      errorDrainAPZ2Plus: "--",
      errorDrainAPN2Plus: "--",
      errorDrainAJZ3Plus: "--",
      errorDrainAJN3Plus: "--",
      errorDrainAPZ4Plus: "--",
      errorDrainAPN4Plus: "--",
      errorDrainAPZM6Plus: "--",
      errorDrainAPNM6Plus: "--",
      errorDrainAJZM5Plus: "--",
      errorDrainAJNM5Plus: "--",
      errorDrainAPZM4Plus: "--",
      errorDrainAPNM4Plus: "--",
      errorDrainAJZM3Plus: "--",
      errorDrainAJNM3Plus: "--",
      errorDrainAPZM2Plus: "--",
      errorDrainAPNM2Plus: "--",
      errorDrainAJZM1Plus: "--",
      errorDrainAJNM1Plus: "--",

      errorDrainBPZ0: "--",
      errorDrainBPN0: "--",
      errorDrainBJZ1: "--",
      errorDrainBJN1: "--",
      errorDrainBPZ2: "--",
      errorDrainBPN2: "--",
      errorDrainBJZ3: "--",
      errorDrainBJN3: "--",
      errorDrainBPZ4: "--",
      errorDrainBPN4: "--",
      errorDrainBPZM6: "--",
      errorDrainBPNM6: "--",
      errorDrainBJZM5: "--",
      errorDrainBJNM5: "--",
      errorDrainBPZM4: "--",
      errorDrainBPNM4: "--",
      errorDrainBJZM3: "--",
      errorDrainBJNM3: "--",
      errorDrainBPZM2: "--",
      errorDrainBPNM2: "--",
      errorDrainBJZM1: "--",
      errorDrainBJNM1: "--",
      errorDrainBPZM0: "--",
      errorDrainBPNM0: "--",
      errorDrainBPZ0Plus: "--",
      errorDrainBPN0Plus: "--",
      errorDrainBJZ1Plus: "--",
      errorDrainBJN1Plus: "--",
      errorDrainBPZ2Plus: "--",
      errorDrainBPN2Plus: "--",
      errorDrainBJZ3Plus: "--",
      errorDrainBJN3Plus: "--",
      errorDrainBPZ4Plus: "--",
      errorDrainBPN4Plus: "--",
      errorDrainBPZM6Plus: "--",
      errorDrainBPNM6Plus: "--",
      errorDrainBJZM5Plus: "--",
      errorDrainBJNM5Plus: "--",
      errorDrainBPZM4Plus: "--",
      errorDrainBPNM4Plus: "--",
      errorDrainBJZM3Plus: "--",
      errorDrainBJNM3Plus: "--",
      errorDrainBPZM2Plus: "--",
      errorDrainBPNM2Plus: "--",
      errorDrainBJZM1Plus: "--",
      errorDrainBJNM1Plus: "--",

      //drain tooltip
      drainATooltipPZ0: "--",
      drainATooltipPN0: "--",
      drainATooltipJZ1: "--",
      drainATooltipJN1: "--",
      drainATooltipPZ2: "--",
      drainATooltipPN2: "--",
      drainATooltipJZ3: "--",
      drainATooltipJN3: "--",
      drainATooltipPZ4: "--",
      drainATooltipPN4: "--",
      drainATooltipPZM6: "--",
      drainATooltipPNM6: "--",
      drainATooltipJZM5: "--",
      drainATooltipJNM5: "--",
      drainATooltipPZM4: "--",
      drainATooltipPNM4: "--",
      drainATooltipJZM3: "--",
      drainATooltipJNM3: "--",
      drainATooltipPZM2: "--",
      drainATooltipPNM2: "--",
      drainATooltipJZM1: "--",
      drainATooltipJNM1: "--",
      drainATooltipPZM0: "--",
      drainATooltipPNM0: "--",
      drainATooltipPZ0Plus: "--",
      drainATooltipPN0Plus: "--",
      drainATooltipJZ1Plus: "--",
      drainATooltipJN1Plus: "--",
      drainATooltipPZ2Plus: "--",
      drainATooltipPN2Plus: "--",
      drainATooltipJZ3Plus: "--",
      drainATooltipJN3Plus: "--",
      drainATooltipPZ4Plus: "--",
      drainATooltipPN4Plus: "--",
      drainATooltipPZM6Plus: "--",
      drainATooltipPNM6Plus: "--",
      drainATooltipJZM5Plus: "--",
      drainATooltipJNM5Plus: "--",
      drainATooltipPZM4Plus: "--",
      drainATooltipPNM4Plus: "--",
      drainATooltipJZM3Plus: "--",
      drainATooltipJNM3Plus: "--",
      drainATooltipPZM2Plus: "--",
      drainATooltipPNM2Plus: "--",
      drainATooltipJZM1Plus: "--",
      drainATooltipJNM1Plus: "--",

      drainBTooltipPZ0: "--",
      drainBTooltipPN0: "--",
      drainBTooltipJZ1: "--",
      drainBTooltipJN1: "--",
      drainBTooltipPZ2: "--",
      drainBTooltipPN2: "--",
      drainBTooltipJZ3: "--",
      drainBTooltipJN3: "--",
      drainBTooltipPZ4: "--",
      drainBTooltipPN4: "--",
      drainBTooltipPZM6: "--",
      drainBTooltipPNM6: "--",
      drainBTooltipJZM5: "--",
      drainBTooltipJNM5: "--",
      drainBTooltipPZM4: "--",
      drainBTooltipPNM4: "--",
      drainBTooltipJZM3: "--",
      drainBTooltipJNM3: "--",
      drainBTooltipPZM2: "--",
      drainBTooltipPNM2: "--",
      drainBTooltipJZM1: "--",
      drainBTooltipJNM1: "--",
      drainBTooltipPZM0: "--",
      drainBTooltipPNM0: "--",
      drainBTooltipPZ0Plus: "--",
      drainBTooltipPN0Plus: "--",
      drainBTooltipJZ1Plus: "--",
      drainBTooltipJN1Plus: "--",
      drainBTooltipPZ2Plus: "--",
      drainBTooltipPN2Plus: "--",
      drainBTooltipJZ3Plus: "--",
      drainBTooltipJN3Plus: "--",
      drainBTooltipPZ4Plus: "--",
      drainBTooltipPN4Plus: "--",
      drainBTooltipPZM6Plus: "--",
      drainBTooltipPNM6Plus: "--",
      drainBTooltipJZM5Plus: "--",
      drainBTooltipJNM5Plus: "--",
      drainBTooltipPZM4Plus: "--",
      drainBTooltipPNM4Plus: "--",
      drainBTooltipJZM3Plus: "--",
      drainBTooltipJNM3Plus: "--",
      drainBTooltipPZM2Plus: "--",
      drainBTooltipPNM2Plus: "--",
      drainBTooltipJZM1Plus: "--",
      drainBTooltipJNM1Plus: "--",

      //running class
      drainAClassPZ0: "--",
      drainAClassPN0: "--",
      drainAClassJZ1: "--",
      drainAClassJN1: "--",
      drainAClassPZ2: "--",
      drainAClassPN2: "--",
      drainAClassJZ3: "--",
      drainAClassJN3: "--",
      drainAClassPZ4: "--",
      drainAClassPN4: "--",
      drainAClassPZM6: "--",
      drainAClassPNM6: "--",
      drainAClassJZM5: "--",
      drainAClassJNM5: "--",
      drainAClassPZM4: "--",
      drainAClassPNM4: "--",
      drainAClassJZM3: "--",
      drainAClassJNM3: "--",
      drainAClassPZM2: "--",
      drainAClassPNM2: "--",
      drainAClassJZM1: "--",
      drainAClassJNM1: "--",
      drainAClassPZM0: "--",
      drainAClassPNM0: "--",
      drainAClassPZ0Plus: "--",
      drainAClassPN0Plus: "--",
      drainAClassJZ1Plus: "--",
      drainAClassJN1Plus: "--",
      drainAClassPZ2Plus: "--",
      drainAClassPN2Plus: "--",
      drainAClassJZ3Plus: "--",
      drainAClassJN3Plus: "--",
      drainAClassPZ4Plus: "--",
      drainAClassPN4Plus: "--",
      drainAClassPZM6Plus: "--",
      drainAClassPNM6Plus: "--",
      drainAClassJZM5Plus: "--",
      drainAClassJNM5Plus: "--",
      drainAClassPZM4Plus: "--",
      drainAClassPNM4Plus: "--",
      drainAClassJZM3Plus: "--",
      drainAClassJNM3Plus: "--",
      drainAClassPZM2Plus: "--",
      drainAClassPNM2Plus: "--",
      drainAClassJZM1Plus: "--",
      drainAClassJNM1Plus: "--",

      drainBClassPZ0: "--",
      drainBClassPN0: "--",
      drainBClassJZ1: "--",
      drainBClassJN1: "--",
      drainBClassPZ2: "--",
      drainBClassPN2: "--",
      drainBClassJZ3: "--",
      drainBClassJN3: "--",
      drainBClassPZ4: "--",
      drainBClassPN4: "--",
      drainBClassPZM6: "--",
      drainBClassPNM6: "--",
      drainBClassJZM5: "--",
      drainBClassJNM5: "--",
      drainBClassPZM4: "--",
      drainBClassPNM4: "--",
      drainBClassJZM3: "--",
      drainBClassJNM3: "--",
      drainBClassPZM2: "--",
      drainBClassPNM2: "--",
      drainBClassJZM1: "--",
      drainBClassJNM1: "--",
      drainBClassPZM0: "--",
      drainBClassPNM0: "--",
      drainBClassPZ0Plus: "--",
      drainBClassPN0Plus: "--",
      drainBClassJZ1Plus: "--",
      drainBClassJN1Plus: "--",
      drainBClassPZ2Plus: "--",
      drainBClassPN2Plus: "--",
      drainBClassJZ3Plus: "--",
      drainBClassJN3Plus: "--",
      drainBClassPZ4Plus: "--",
      drainBClassPN4Plus: "--",
      drainBClassPZM6Plus: "--",
      drainBClassPNM6Plus: "--",
      drainBClassJZM5Plus: "--",
      drainBClassJNM5Plus: "--",
      drainBClassPZM4Plus: "--",
      drainBClassPNM4Plus: "--",
      drainBClassJZM3Plus: "--",
      drainBClassJNM3Plus: "--",
      drainBClassPZM2Plus: "--",
      drainBClassPNM2Plus: "--",
      drainBClassJZM1Plus: "--",
      drainBClassJNM1Plus: "--",

      dataNameIdDict: {
        //valve drain
        valvePZ0: "c6a307c3-83ae-4ae0-876c-3e6349781308",
        valvePN0: "87ab6cd9-a0c0-40c6-a882-2eceae1d95c5",
        valveJZ1: "2ddce89f-6799-4549-9fbd-c517df3ddf7f",
        valveJN1: "6bb0f612-5dec-447c-9802-1ed5b8c94f4b",
        valvePZ2: "3415a2e5-4651-48fd-ad0d-166bb80607d0",
        valvePN2: "64dc5e51-9365-4b02-843a-3ebf8274296c",
        valveJZ3: "bd64140c-fd75-4684-862c-abb255f4f758",
        valveJN3: "84fe30b7-2912-4477-b5ce-6762300c7192",
        valvePZ4: "d53a115a-2c41-4413-8484-9f8f036fa074",
        valvePN4: "a429ace1-df24-4690-95f3-0603d0306c92",
        valvePZM6: "1d612a9b-af46-47d1-aa0e-e45de0c22471",
        valvePNM6: "98e44e99-4f9d-4b57-9e85-7392aa78b766",
        valveJZM5: "b55a40b1-b944-4a7b-8e8c-afe55a8a4044",
        valveJNM5: "6e4bf1a0-8235-4e6e-ba97-52d0c2ee9f80",
        valvePZM4: "9dcc982e-8298-472b-8820-78c0b7519d6e",
        valvePNM4: "691c8dd6-dc84-47af-ba1a-6c805f323e97",
        valveJZM3: "1d785983-a114-41ac-ae68-61c3c5e027ad",
        valveJNM3: "81a8f157-1b40-44f2-81c8-34a8e120965b",
        valvePZM2: "0b04460f-30bb-43e9-82c6-216cc9888259",
        valvePNM2: "f695730a-5c51-48be-a560-a86379aeb0da",
        valveJZM1: "6cfc95c5-56ce-42fa-a86c-ad1182a93b98",
        valveJNM1: "f622fce7-87f6-40d0-94dd-d43758784c9d",
        valvePZM0: "65cdc8e7-7b77-41fc-84ed-f0aca184e40b",
        valvePNM0: "6aafab31-41e7-4a46-9b1b-3328d66d42fd",
        valvePZ0Plus: "6f1bf487-eb4c-43a2-8ca0-cdd485136ce4",
        valvePN0Plus: "d8b8b591-ba01-4e58-9889-4e238bae635f",
        valveJZ1Plus: "b622e371-e98d-4e82-bef9-5f2b482bdc9e",
        valveJN1Plus: "0ff680a9-843d-417c-a6d1-edf648efe933",
        valvePZ2Plus: "2b3106e3-98a0-4a0f-a14c-270217a05f9e",
        valvePN2Plus: "6e5a2cc9-d72a-4a95-8751-cbe46ede9636",
        valveJZ3Plus: "d614bcdc-93ed-49e6-9884-c8825154e9c1",
        valveJN3Plus: "91862361-0f47-457b-b3c6-0c397ca60b9b",
        valvePZ4Plus: "b8ec72b5-97e4-4896-a926-4cf5662152cf",
        valvePN4Plus: "d4db6b6c-00fe-4a89-a0a2-c5b89d17ffbd",
        valvePZM6Plus: "741cfcfc-a41c-40bb-b57e-7913ff81ae34",
        valvePNM6Plus: "51006774-6f0e-4e70-aa64-19a154c07cc1",
        valveJZM5Plus: "e9d77ed6-2216-4363-95e4-329c901a4e68",
        valveJNM5Plus: "2e15a1b6-76ee-4317-8148-56a090134041",
        valvePZM4Plus: "3c19c528-8a6d-4f90-bf0c-b9d562233cd7",
        valvePNM4Plus: "dea914d8-be93-458d-b4e4-ce47cbdd4c87",
        valveJZM3Plus: "eae1cc73-e388-4584-8383-652f89fe697b",
        valveJNM3Plus: "68b8a1c2-c1a6-4d8d-b69e-55e76e871665",
        valvePZM2Plus: "54d3eec7-5a25-4bbf-836e-7d77e7ed2356",
        valvePNM2Plus: "ad087fff-39ba-4b17-bf7c-7876a895384f",
        valveJZM1Plus: "c0609c44-b092-4300-943f-aaae0232dfac",
        valveJNM1Plus: "12b539b4-2a40-466b-87df-a95786a94661",

        drainAPZ0: "167fcfbd-6bb4-4dd2-9fbb-e2e89f6d3789",
        drainAPN0: "e09f1e47-4bf2-4958-9d5b-1948cebbfa8a",
        drainAJZ1: "82e9b80f-79bc-4618-9905-609258f97720",
        drainAJN1: "c061bd0b-8c01-411f-a403-8042af975895",
        drainAPZ2: "7974d5be-6abc-4d9d-9013-75d3bbe19fa1",
        drainAPN2: "1717a62f-2dbc-4e4a-bedf-0bc22de16ecf",
        drainAJZ3: "1af83092-7742-4700-a4c1-9b970faecb3e",
        drainAJN3: "94ed3587-4b71-48bb-8249-5a0603f83a2b",
        drainAPZ4: "1fb973c0-c86e-4974-a2ea-e23a603d0ff9",
        drainAPN4: "d72a0981-9494-4bd3-91a1-3c800ee8562a",
        drainAPZM6: "e09081ce-3099-454a-b451-393a2035ebc9",
        drainAPNM6: "fd2c5ff8-fb74-4291-9de1-705ef5961990",
        drainAJZM5: "63658366-8f44-4f2e-80d9-a29742dbfc2d",
        drainAJNM5: "e2bac911-1753-446b-af29-a5f52813f8e0",
        drainAPZM4: "29d0f718-e495-47aa-9c43-59f22efe3e3d",
        drainAPNM4: "2daa7e2b-9553-450e-bb3a-b34c998cd083",
        drainAJZM3: "03b5c310-0031-4fba-8798-19d241cda475",
        drainAJNM3: "77db8fb6-af1d-4566-be97-4cc4740610d6",
        drainAPZM2: "f8c9c198-cd7f-443a-8f0f-82c407e40bc8",
        drainAPNM2: "c1b91015-bed9-43b3-9360-5a4e635ec734",
        drainAJZM1: "bee8c79f-fc87-4f76-bf91-fb8f35f3dfd4",
        drainAJNM1: "84dbed38-564d-4bc3-8738-1b3acea192cc",
        drainAPZM0: "b2f966c1-d054-4072-8f40-ce3f0c481d9b",
        drainAPNM0: "1bf4ae9b-a1ca-4a5f-9158-34746bb82ab0",
        drainAPZ0Plus: "cbb31c68-cffd-40bf-b9a8-95edeafcf62c",
        drainAPN0Plus: "641e9425-ebe2-40e2-8a59-1d113808578f",
        drainAJZ1Plus: "edfbe68a-45b7-41be-824f-63c60f8a0255",
        drainAJN1Plus: "d8f95a94-bc6c-4978-893a-b6682ded6da2",
        drainAPZ2Plus: "a18c1b49-861a-4e96-b2ed-999b9d51ef2d",
        drainAPN2Plus: "117820bb-6036-4773-a63c-6ecb98e046a8",
        drainAJZ3Plus: "2c11cd73-bc59-4266-ac52-044d5d88053c",
        drainAJN3Plus: "bd616c80-7bd0-4bcb-806b-45f9dbecd3ad",
        drainAPZ4Plus: "831dc90a-24da-4d9e-a56d-28382f1090f8",
        drainAPN4Plus: "2726c9e9-3c1d-420c-8345-c95170b32364",
        drainAPZM6Plus: "2e5f491b-a8df-4d7d-8649-07ae047fe821",
        drainAPNM6Plus: "2d52c364-a722-477a-9ef7-fe5d40ddebc0",
        drainAJZM5Plus: "8663ef6a-649f-4482-9840-e5707cb62b90",
        drainAJNM5Plus: "fbcb24fa-cfc6-4a1f-bce5-0afa7b72d234",
        drainAPZM4Plus: "8c50144a-ea85-4aff-ab7b-a759c40edca5",
        drainAPNM4Plus: "5ea5ea22-03fd-47ca-a56d-7be4b5383272",
        drainAJZM3Plus: "b5025543-3171-4ef1-a3a3-e32be4468159",
        drainAJNM3Plus: "fb4c7164-3783-4af5-9ed8-a8fc87bbd2b8",
        drainAPZM2Plus: "4b299238-25d0-4705-9665-af27e03b6d24",
        drainAPNM2Plus: "8557b036-f3ec-4fc1-bdae-d949ec879850",
        drainAJZM1Plus: "3d6693dc-1ec7-429f-a74d-e9aef10dbbf4",
        drainAJNM1Plus: "a1a29245-fa34-4286-9894-4471e7ee9ad8",

        drainBPZ0: "81670549-6dc6-487b-a56d-d394db8dd17b",
        drainBPN0: "237741f5-4c1a-47d2-8c79-1202453ab00b",
        drainBJZ1: "186da16d-0cdf-40c2-94ff-455d26e6eb90",
        drainBJN1: "f8d81bea-76ca-478b-8ed9-2e2924535b56",
        drainBPZ2: "147285b0-ba14-4f27-9597-8f8c745afac0",
        drainBPN2: "520fe40d-2edb-4ad0-a237-38c4b58003cc",
        drainBJZ3: "0410fac8-1e3c-4816-8d8a-5f1eb9f9f13a",
        drainBJN3: "eada00dc-21e7-4863-a421-00f41470b813",
        drainBPZ4: "42a9b145-15e5-46c1-8e56-23df4cd587fd",
        drainBPN4: "f66a9aec-9cba-47b5-be1f-9aa738173918",
        drainBPZM6: "bafee9f5-f211-49c3-bef2-d3449c3e7f67",
        drainBPNM6: "b91f3fa2-2047-4a3c-bddf-d6941c7fb760",
        drainBJZM5: "444d2192-b7fa-4a5f-b841-7f376a1aee09",
        drainBJNM5: "8c069742-e3fd-41fb-9dd0-0bb14046d630",
        drainBPZM4: "f1098054-d6c2-4413-bfeb-d341b2996e84",
        drainBPNM4: "e01bc2b4-285d-411e-a44f-96adcccf7d68",
        drainBJZM3: "d6ae55cf-4ae8-40b2-accf-e5c4d5cdde42",
        drainBJNM3: "6c2078d7-465d-421c-9f20-19c035afa74e",
        drainBPZM2: "db65bc4d-3722-40cd-bfd2-003ac955c104",
        drainBPNM2: "94bbecb1-d1be-4688-aa6b-e338d1ce6d05",
        drainBJZM1: "d7e6ceab-b01d-4f8b-8157-588ae8fd4cf8",
        drainBJNM1: "5b57ea58-a897-4707-962e-91344b1246fd",
        drainBPZM0: "1a763f99-a0ea-4a92-9f57-3d55f349aa29",
        drainBPNM0: "2aa0fb9c-9a10-4e48-8822-c3cb0040268f",
        drainBPZ0Plus: "f6323bbb-dbc7-4bc8-a98f-0e20a6f076c6",
        drainBPN0Plus: "0d6f879e-04fe-45f1-873c-e4433e4d9f74",
        drainBJZ1Plus: "451c6c04-e9ef-4909-a447-473669b94149",
        drainBJN1Plus: "3aff1c3b-a5ce-403e-9c39-df3fb84813a0",
        drainBPZ2Plus: "7f09cee9-b099-425b-b6ca-6a094712ac2a",
        drainBPN2Plus: "9864226b-3b9d-4cb2-95ec-5af9e57fc35a",
        drainBJZ3Plus: "452c308c-9215-4d21-8f91-6c9d3bbc606c",
        drainBJN3Plus: "f6462cde-124f-41b7-8326-13c99e19d4f1",
        drainBPZ4Plus: "58f404c7-1577-4b52-bf11-6b3df404395d",
        drainBPN4Plus: "95175bda-2b76-4d85-a3ac-35b965264f58",
        drainBPZM6Plus: "467bdb14-ba5e-4092-a6e5-b4b7c90dcce1",
        drainBPNM6Plus: "5e472217-20a7-4866-b1de-16067a52e4d7",
        drainBJZM5Plus: "9d6d0805-0a3b-4518-83a8-e39d8a069c7b",
        drainBJNM5Plus: "0f7aca42-ac1d-4665-914f-4643298aa155",
        drainBPZM4Plus: "2a62bd44-6dd3-4d66-89d8-8a508de1f989",
        drainBPNM4Plus: "b56e5e46-13c2-430d-b034-142c2d0592a2",
        drainBJZM3Plus: "fe486b2d-b8ba-4a06-9e0a-50953bb0b5d3",
        drainBJNM3Plus: "da211d74-6f4e-47b2-a915-27e149a5c7fd",
        drainBPZM2Plus: "678de1ff-4aca-43fa-8ad9-2d66415b56d9",
        drainBPNM2Plus: "f23bd242-ec82-480f-aafd-2d8b7db5eac8",
        drainBJZM1Plus: "bd86b0c7-789d-460f-827d-b18115671708",
        drainBJNM1Plus: "27b2f0c6-f4b1-41fa-9adf-1a1175bf67e6",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {},

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        valvePZ0: "errorPZ0",
        valvePN0: "errorPN0",
        valveJZ1: "errorJZ1",
        valveJN1: "errorJN1",
        valvePZ2: "errorPZ2",
        valvePN2: "errorPN2",
        valveJZ3: "errorJZ3",
        valveJN3: "errorJN3",
        valvePZ4: "errorPZ4",
        valvePN4: "errorPN4",
        valvePZM6: "errorPZM6",
        valvePNM6: "errorPNM6",
        valveJZM5: "errorJZM5",
        valveJNM5: "errorJNM5",
        valvePZM4: "errorPZM4",
        valvePNM4: "errorPNM4",
        valveJZM3: "errorJZM3",
        valveJNM3: "errorJNM3",
        valvePZM2: "errorPZM2",
        valvePNM2: "errorPNM2",
        valveJZM1: "errorJZM1",
        valveJNM1: "errorJNM1",
        valvePZM0: "errorPZM0",
        valvePNM0: "errorPNM0",
        valvePZ0Plus: "errorPZ0Plus",
        valvePN0Plus: "errorPN0Plus",
        valveJZ1Plus: "errorJZ1Plus",
        valveJN1Plus: "errorJN1Plus",
        valvePZ2Plus: "errorPZ2Plus",
        valvePN2Plus: "errorPN2Plus",
        valveJZ3Plus: "errorJZ3Plus",
        valveJN3Plus: "errorJN3Plus",
        valvePZ4Plus: "errorPZ4Plus",
        valvePN4Plus: "errorPN4Plus",
        valvePZM6Plus: "errorPZM6Plus",
        valvePNM6Plus: "errorPNM6Plus",
        valveJZM5Plus: "errorJZM5Plus",
        valveJNM5Plus: "errorJNM5Plus",
        valvePZM4Plus: "errorPZM4Plus",
        valvePNM4Plus: "errorPNM4Plus",
        valveJZM3Plus: "errorJZM3Plus",
        valveJNM3Plus: "errorJNM3Plus",
        valvePZM2Plus: "errorPZM2Plus",
        valvePNM2Plus: "errorPNM2Plus",
        valveJZM1Plus: "errorJZM1Plus",
        valveJNM1Plus: "errorJNM1Plus",

        drainAPZ0: "errorPZ0, errorDrainAPZ0",
        drainAPN0: "errorPN0, errorDrainAPN0",
        drainAJZ1: "errorJZ1, errorDrainAJZ1",
        drainAJN1: "errorJN1, errorDrainAJN1",
        drainAPZ2: "errorPZ2, errorDrainAPZ2",
        drainAPN2: "errorPN2, errorDrainAPN2",
        drainAJZ3: "errorJZ3, errorDrainAJZ3",
        drainAJN3: "errorJN3, errorDrainAJN3",
        drainAPZ4: "errorPZ4, errorDrainAPZ4",
        drainAPN4: "errorPN4, errorDrainAPN4",
        drainAPZM6: "errorPZM6, errorDrainAPZM6",
        drainAPNM6: "errorPNM6, errorDrainAPNM6",
        drainAJZM5: "errorJZM5, errorDrainAJZM5",
        drainAJNM5: "errorJNM5, errorDrainAJNM5",
        drainAPZM4: "errorPZM4, errorDrainAPZM4",
        drainAPNM4: "errorPNM4, errorDrainAPNM4",
        drainAJZM3: "errorJZM3, errorDrainAJZM3",
        drainAJNM3: "errorJNM3, errorDrainAJNM3",
        drainAPZM2: "errorPZM2, errorDrainAPZM2",
        drainAPNM2: "errorPNM2, errorDrainAPNM2",
        drainAJZM1: "errorJZM1, errorDrainAJZM1",
        drainAJNM1: "errorJNM1, errorDrainAJNM1",
        drainAPZM0: "errorPZM0, errorDrainAPZM0",
        drainAPNM0: "errorPNM0, errorDrainAPNM0",
        drainAPZ0Plus: "errorPZ0Plus, errorDrainAPZ0Plus",
        drainAPN0Plus: "errorPN0Plus, errorDrainAPN0Plus",
        drainAJZ1Plus: "errorJZ1Plus, errorDrainAJZ1Plus",
        drainAJN1Plus: "errorJN1Plus, errorDrainAJN1Plus",
        drainAPZ2Plus: "errorPZ2Plus, errorDrainAPZ2Plus",
        drainAPN2Plus: "errorPN2Plus, errorDrainAPN2Plus",
        drainAJZ3Plus: "errorJZ3Plus, errorDrainAJZ3Plus",
        drainAJN3Plus: "errorJN3Plus, errorDrainAJN3Plus",
        drainAPZ4Plus: "errorPZ4Plus, errorDrainAPZ4Plus",
        drainAPN4Plus: "errorPN4Plus, errorDrainAPN4Plus",
        drainAPZM6Plus: "errorPZM6Plus, errorDrainAPZM6Plus",
        drainAPNM6Plus: "errorPNM6Plus, errorDrainAPNM6Plus",
        drainAJZM5Plus: "errorJZM5Plus, errorDrainAJZM5Plus",
        drainAJNM5Plus: "errorJNM5Plus, errorDrainAJNM5Plus",
        drainAPZM4Plus: "errorPZM4Plus, errorDrainAPZM4Plus",
        drainAPNM4Plus: "errorPNM4Plus, errorDrainAPNM4Plus",
        drainAJZM3Plus: "errorJZM3Plus, errorDrainAJZM3Plus",
        drainAJNM3Plus: "errorJNM3Plus, errorDrainAJNM3Plus",
        drainAPZM2Plus: "errorPZM2Plus, errorDrainAPZM2Plus",
        drainAPNM2Plus: "errorPNM2Plus, errorDrainAPNM2Plus",
        drainAJZM1Plus: "errorJZM1Plus, errorDrainAJZM1Plus",
        drainAJNM1Plus: "errorJNM1Plus, errorDrainAJNM1Plus",

        drainBPZ0: "errorPZ0, errorDrainBPZ0",
        drainBPN0: "errorPN0, errorDrainBPN0",
        drainBJZ1: "errorJZ1, errorDrainBJZ1",
        drainBJN1: "errorJN1, errorDrainBJN1",
        drainBPZ2: "errorPZ2, errorDrainBPZ2",
        drainBPN2: "errorPN2, errorDrainBPN2",
        drainBJZ3: "errorJZ3, errorDrainBJZ3",
        drainBJN3: "errorJN3, errorDrainBJN3",
        drainBPZ4: "errorPZ4, errorDrainBPZ4",
        drainBPN4: "errorPN4, errorDrainBPN4",
        drainBPZM6: "errorPZM6, errorDrainBPZM6",
        drainBPNM6: "errorPNM6, errorDrainBPNM6",
        drainBJZM5: "errorJZM5, errorDrainBJZM5",
        drainBJNM5: "errorJNM5, errorDrainBJNM5",
        drainBPZM4: "errorPZM4, errorDrainBPZM4",
        drainBPNM4: "errorPNM4, errorDrainBPNM4",
        drainBJZM3: "errorJZM3, errorDrainBJZM3",
        drainBJNM3: "errorJNM3, errorDrainBJNM3",
        drainBPZM2: "errorPZM2, errorDrainBPZM2",
        drainBPNM2: "errorPNM2, errorDrainBPNM2",
        drainBJZM1: "errorJZM1, errorDrainBJZM1",
        drainBJNM1: "errorJNM1, errorDrainBJNM1",
        drainBPZM0: "errorPZM0, errorDrainBPZM0",
        drainBPNM0: "errorPNM0, errorDrainBPNM0",
        drainBPZ0Plus: "errorPZ0Plus, errorDrainBPZ0Plus",
        drainBPN0Plus: "errorPN0Plus, errorDrainBPN0Plus",
        drainBJZ1Plus: "errorJZ1Plus, errorDrainBJZ1Plus",
        drainBJN1Plus: "errorJN1Plus, errorDrainBJN1Plus",
        drainBPZ2Plus: "errorPZ2Plus, errorDrainBPZ2Plus",
        drainBPN2Plus: "errorPN2Plus, errorDrainBPN2Plus",
        drainBJZ3Plus: "errorJZ3Plus, errorDrainBJZ3Plus",
        drainBJN3Plus: "errorJN3Plus, errorDrainBJN3Plus",
        drainBPZ4Plus: "errorPZ4Plus, errorDrainBPZ4Plus",
        drainBPN4Plus: "errorPN4Plus, errorDrainBPN4Plus",
        drainBPZM6Plus: "errorPZM6Plus, errorDrainBPZM6Plus",
        drainBPNM6Plus: "errorPNM6Plus, errorDrainBPNM6Plus",
        drainBJZM5Plus: "errorJZM5Plus, errorDrainBJZM5Plus",
        drainBJNM5Plus: "errorJNM5Plus, errorDrainBJNM5Plus",
        drainBPZM4Plus: "errorPZM4Plus, errorDrainBPZM4Plus",
        drainBPNM4Plus: "errorPNM4Plus, errorDrainBPNM4Plus",
        drainBJZM3Plus: "errorJZM3Plus, errorDrainBJZM3Plus",
        drainBJNM3Plus: "errorJNM3Plus, errorDrainBJNM3Plus",
        drainBPZM2Plus: "errorPZM2Plus, errorDrainBPZM2Plus",
        drainBPNM2Plus: "errorPNM2Plus, errorDrainBPNM2Plus",
        drainBJZM1Plus: "errorJZM1Plus, errorDrainBJZM1Plus",
        drainBJNM1Plus: "errorJNM1Plus, errorDrainBJNM1Plus",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {},

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        drainAPZ0: "drainATooltipPZ0",
        drainAPN0: "drainATooltipPN0",
        drainAJZ1: "drainATooltipJZ1",
        drainAJN1: "drainATooltipJN1",
        drainAPZ2: "drainATooltipPZ2",
        drainAPN2: "drainATooltipPN2",
        drainAJZ3: "drainATooltipJZ3",
        drainAJN3: "drainATooltipJN3",
        drainAPZ4: "drainATooltipPZ4",
        drainAPN4: "drainATooltipPN4",
        drainAPZM6: "drainATooltipPZM6",
        drainAPNM6: "drainATooltipPNM6",
        drainAJZM5: "drainATooltipJZM5",
        drainAJNM5: "drainATooltipJNM5",
        drainAPZM4: "drainATooltipPZM4",
        drainAPNM4: "drainATooltipPNM4",
        drainAJZM3: "drainATooltipJZM3",
        drainAJNM3: "drainATooltipJNM3",
        drainAPZM2: "drainATooltipPZM2",
        drainAPNM2: "drainATooltipPNM2",
        drainAJZM1: "drainATooltipJZM1",
        drainAJNM1: "drainATooltipJNM1",
        drainAPZM0: "drainATooltipPZM0",
        drainAPNM0: "drainATooltipPNM0",
        drainAPZ0Plus: "drainATooltipPZ0Plus",
        drainAPN0Plus: "drainATooltipPN0Plus",
        drainAJZ1Plus: "drainATooltipJZ1Plus",
        drainAJN1Plus: "drainATooltipJN1Plus",
        drainAPZ2Plus: "drainATooltipPZ2Plus",
        drainAPN2Plus: "drainATooltipPN2Plus",
        drainAJZ3Plus: "drainATooltipJZ3Plus",
        drainAJN3Plus: "drainATooltipJN3Plus",
        drainAPZ4Plus: "drainATooltipPZ4Plus",
        drainAPN4Plus: "drainATooltipPN4Plus",
        drainAPZM6Plus: "drainATooltipPZM6Plus",
        drainAPNM6Plus: "drainATooltipPNM6Plus",
        drainAJZM5Plus: "drainATooltipJZM5Plus",
        drainAJNM5Plus: "drainATooltipJNM5Plus",
        drainAPZM4Plus: "drainATooltipPZM4Plus",
        drainAPNM4Plus: "drainATooltipPNM4Plus",
        drainAJZM3Plus: "drainATooltipJZM3Plus",
        drainAJNM3Plus: "drainATooltipJNM3Plus",
        drainAPZM2Plus: "drainATooltipPZM2Plus",
        drainAPNM2Plus: "drainATooltipPNM2Plus",
        drainAJZM1Plus: "drainATooltipJZM1Plus",
        drainAJNM1Plus: "drainATooltipJNM1Plus",

        drainBPZ0: "drainBTooltipPZ0",
        drainBPN0: "drainBTooltipPN0",
        drainBJZ1: "drainBTooltipJZ1",
        drainBJN1: "drainBTooltipJN1",
        drainBPZ2: "drainBTooltipPZ2",
        drainBPN2: "drainBTooltipPN2",
        drainBJZ3: "drainBTooltipJZ3",
        drainBJN3: "drainBTooltipJN3",
        drainBPZ4: "drainBTooltipPZ4",
        drainBPN4: "drainBTooltipPN4",
        drainBPZM6: "drainBTooltipPZM6",
        drainBPNM6: "drainBTooltipPNM6",
        drainBJZM5: "drainBTooltipJZM5",
        drainBJNM5: "drainBTooltipJNM5",
        drainBPZM4: "drainBTooltipPZM4",
        drainBPNM4: "drainBTooltipPNM4",
        drainBJZM3: "drainBTooltipJZM3",
        drainBJNM3: "drainBTooltipJNM3",
        drainBPZM2: "drainBTooltipPZM2",
        drainBPNM2: "drainBTooltipPNM2",
        drainBJZM1: "drainBTooltipJZM1",
        drainBJNM1: "drainBTooltipJNM1",
        drainBPZM0: "drainBTooltipPZM0",
        drainBPNM0: "drainBTooltipPNM0",
        drainBPZ0Plus: "drainBTooltipPZ0Plus",
        drainBPN0Plus: "drainBTooltipPN0Plus",
        drainBJZ1Plus: "drainBTooltipJZ1Plus",
        drainBJN1Plus: "drainBTooltipJN1Plus",
        drainBPZ2Plus: "drainBTooltipPZ2Plus",
        drainBPN2Plus: "drainBTooltipPN2Plus",
        drainBJZ3Plus: "drainBTooltipJZ3Plus",
        drainBJN3Plus: "drainBTooltipJN3Plus",
        drainBPZ4Plus: "drainBTooltipPZ4Plus",
        drainBPN4Plus: "drainBTooltipPN4Plus",
        drainBPZM6Plus: "drainBTooltipPZM6Plus",
        drainBPNM6Plus: "drainBTooltipPNM6Plus",
        drainBJZM5Plus: "drainBTooltipJZM5Plus",
        drainBJNM5Plus: "drainBTooltipJNM5Plus",
        drainBPZM4Plus: "drainBTooltipPZM4Plus",
        drainBPNM4Plus: "drainBTooltipPNM4Plus",
        drainBJZM3Plus: "drainBTooltipJZM3Plus",
        drainBJNM3Plus: "drainBTooltipJNM3Plus",
        drainBPZM2Plus: "drainBTooltipPZM2Plus",
        drainBPNM2Plus: "drainBTooltipPNM2Plus",
        drainBJZM1Plus: "drainBTooltipJZM1Plus",
        drainBJNM1Plus: "drainBTooltipJNM1Plus",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        drainAPZ0: "drainAClassPZ0",
        drainAPN0: "drainAClassPN0",
        drainAJZ1: "drainAClassJZ1",
        drainAJN1: "drainAClassJN1",
        drainAPZ2: "drainAClassPZ2",
        drainAPN2: "drainAClassPN2",
        drainAJZ3: "drainAClassJZ3",
        drainAJN3: "drainAClassJN3",
        drainAPZ4: "drainAClassPZ4",
        drainAPN4: "drainAClassPN4",
        drainAPZM6: "drainAClassPZM6",
        drainAPNM6: "drainAClassPNM6",
        drainAJZM5: "drainAClassJZM5",
        drainAJNM5: "drainAClassJNM5",
        drainAPZM4: "drainAClassPZM4",
        drainAPNM4: "drainAClassPNM4",
        drainAJZM3: "drainAClassJZM3",
        drainAJNM3: "drainAClassJNM3",
        drainAPZM2: "drainAClassPZM2",
        drainAPNM2: "drainAClassPNM2",
        drainAJZM1: "drainAClassJZM1",
        drainAJNM1: "drainAClassJNM1",
        drainAPZM0: "drainAClassPZM0",
        drainAPNM0: "drainAClassPNM0",
        drainAPZ0Plus: "drainAClassPZ0Plus",
        drainAPN0Plus: "drainAClassPN0Plus",
        drainAJZ1Plus: "drainAClassJZ1Plus",
        drainAJN1Plus: "drainAClassJN1Plus",
        drainAPZ2Plus: "drainAClassPZ2Plus",
        drainAPN2Plus: "drainAClassPN2Plus",
        drainAJZ3Plus: "drainAClassJZ3Plus",
        drainAJN3Plus: "drainAClassJN3Plus",
        drainAPZ4Plus: "drainAClassPZ4Plus",
        drainAPN4Plus: "drainAClassPN4Plus",
        drainAPZM6Plus: "drainAClassPZM6Plus",
        drainAPNM6Plus: "drainAClassPNM6Plus",
        drainAJZM5Plus: "drainAClassJZM5Plus",
        drainAJNM5Plus: "drainAClassJNM5Plus",
        drainAPZM4Plus: "drainAClassPZM4Plus",
        drainAPNM4Plus: "drainAClassPNM4Plus",
        drainAJZM3Plus: "drainAClassJZM3Plus",
        drainAJNM3Plus: "drainAClassJNM3Plus",
        drainAPZM2Plus: "drainAClassPZM2Plus",
        drainAPNM2Plus: "drainAClassPNM2Plus",
        drainAJZM1Plus: "drainAClassJZM1Plus",
        drainAJNM1Plus: "drainAClassJNM1Plus",

        drainBPZ0: "drainBClassPZ0",
        drainBPN0: "drainBClassPN0",
        drainBJZ1: "drainBClassJZ1",
        drainBJN1: "drainBClassJN1",
        drainBPZ2: "drainBClassPZ2",
        drainBPN2: "drainBClassPN2",
        drainBJZ3: "drainBClassJZ3",
        drainBJN3: "drainBClassJN3",
        drainBPZ4: "drainBClassPZ4",
        drainBPN4: "drainBClassPN4",
        drainBPZM6: "drainBClassPZM6",
        drainBPNM6: "drainBClassPNM6",
        drainBJZM5: "drainBClassJZM5",
        drainBJNM5: "drainBClassJNM5",
        drainBPZM4: "drainBClassPZM4",
        drainBPNM4: "drainBClassPNM4",
        drainBJZM3: "drainBClassJZM3",
        drainBJNM3: "drainBClassJNM3",
        drainBPZM2: "drainBClassPZM2",
        drainBPNM2: "drainBClassPNM2",
        drainBJZM1: "drainBClassJZM1",
        drainBJNM1: "drainBClassJNM1",
        drainBPZM0: "drainBClassPZM0",
        drainBPNM0: "drainBClassPNM0",
        drainBPZ0Plus: "drainBClassPZ0Plus",
        drainBPN0Plus: "drainBClassPN0Plus",
        drainBJZ1Plus: "drainBClassJZ1Plus",
        drainBJN1Plus: "drainBClassJN1Plus",
        drainBPZ2Plus: "drainBClassPZ2Plus",
        drainBPN2Plus: "drainBClassPN2Plus",
        drainBJZ3Plus: "drainBClassJZ3Plus",
        drainBJN3Plus: "drainBClassJN3Plus",
        drainBPZ4Plus: "drainBClassPZ4Plus",
        drainBPN4Plus: "drainBClassPN4Plus",
        drainBPZM6Plus: "drainBClassPZM6Plus",
        drainBPNM6Plus: "drainBClassPNM6Plus",
        drainBJZM5Plus: "drainBClassJZM5Plus",
        drainBJNM5Plus: "drainBClassJNM5Plus",
        drainBPZM4Plus: "drainBClassPZM4Plus",
        drainBPNM4Plus: "drainBClassPNM4Plus",
        drainBJZM3Plus: "drainBClassJZM3Plus",
        drainBJNM3Plus: "drainBClassJNM3Plus",
        drainBPZM2Plus: "drainBClassPZM2Plus",
        drainBPNM2Plus: "drainBClassPNM2Plus",
        drainBJZM1Plus: "drainBClassJZM1Plus",
        drainBJNM1Plus: "drainBClassJNM1Plus",
      },

      //station id list
      stationIdList: [
        "923f7894-bd81-4bc7-aace-137362d1dfcc",
        "9898ec82-1984-4f9f-b4ef-f8e1019c5176",
        "236a0656-c054-4af8-9610-d654fd72630a",
        "f5dac257-4b54-4292-9cf7-36e733aa8f65",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            let errorNameList = [errorName];
            if (errorName.indexOf(",") > 0) {
              errorNameList = errorName.split(",");
            }

            for (let errorNameItem of errorNameList) {
              this[errorNameItem] = this.getErrorLevelFromMultipleDevice(this[errorNameItem], stationData[dataId].errorLevel);
            }
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
    assembleTooltip_drain(name, errorLevel, runningFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else {
        if (runningFlag > 0) {
          result += "开启";
        } else if (runningFlag === 0) {
          result += "关闭";
        }
      }

      return result;
    },
    hrefToScenario(id) {
      if (!id || id === "") {
        return;
      }

      this.$router.push("/" + this.routerPrefix + "/dataHistory?bridgeId=" + this.bridgeId + "&scenarioId=" + id);
    },
    hrefToStation(id) {
      if (!id || id === "") {
        return;
      }

      this.$router.push("/" + this.routerPrefix + id);
    },
  },
};
</script>
        
        <style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        font-weight: bold;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/xihoumen/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 94%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 90%;
              transform: translate(0%, 0%);
            }
            &.top-pos:before {
              left: 50%;
              top: -3px;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .sensor-right-1 {
          top: 184px;
          left: 1132px;
          &::before {
            bottom: 22px;
            left: -3px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -165px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-3 {
          top: 153px;
          left: 1050px;
          &::before {
            bottom: -40px;
            left: -34px;
            width: 100px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -89px;
            left: 24px;
          }
          .state-info {
            right: -165px;
            top: 103px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-5 {
          top: 117px;
          left: 962px;
          &::before {
            bottom: 35px;
            left: -17px;
            width: 60px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 64px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: -49px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-13 {
          top: 117px;
          left: 937px;
          &::before {
            bottom: 45px;
            left: -45px;
            width: 90px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 89px;
            left: -23px;
          }
          .state-info {
            right: 40px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-11 {
          top: 150px;
          left: 835px;
          &::before {
            bottom: 22px;
            left: -21px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -26px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-9 {
          top: 170px;
          left: 732px;
          &::before {
            bottom: -25px;
            left: -22px;
            width: 70px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -59px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-7 {
          top: 180px;
          left: 625px;
          &::before {
            bottom: -5px;
            left: -4px;
            width: 25px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -61px;
            top: 59px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-5 {
          top: 170px;
          left: 518px;
          &::before {
            bottom: -25px;
            left: -32px;
            width: 70px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -59px;
            left: -18px;
          }
          .state-info {
            right: 33px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-3 {
          top: 150px;
          left: 405px;
          &::before {
            bottom: 22px;
            left: -2px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -170px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-1 {
          top: 117px;
          left: 300px;
          &::before {
            bottom: 45px;
            left: -30px;
            width: 90px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 89px;
            left: 23px;
          }
          .state-info {
            right: -165px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-5 {
          top: 117px;
          left: 275px;
          &::before {
            bottom: 35px;
            left: -28px;
            width: 60px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 64px;
            left: -18px;
          }
          .state-info {
            right: 35px;
            top: -49px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-3 {
          top: 157px;
          left: 175px;
          &::before {
            bottom: -40px;
            left: -51px;
            width: 100px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -89px;
            left: -24px;
          }
          .state-info {
            right: 40px;
            top: 103px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-1 {
          top: 182px;
          left: 72px;
          &::before {
            bottom: 22px;
            left: -23px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -27px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-2 {
          top: 168px;
          left: 1093px;
          &::before {
            bottom: 22px;
            left: -3px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -165px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-4 {
          top: 132px;
          left: 998px;
          &::before {
            bottom: 38px;
            left: -21px;
            width: 70px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 73px;
            left: 20px;
          }
          .state-info {
            right: -165px;
            top: -58px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-12 {
          top: 135px;
          left: 885px;
          &::before {
            bottom: 45px;
            left: -45px;
            width: 90px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 89px;
            left: -23px;
          }
          .state-info {
            right: 40px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-10 {
          top: 158px;
          left: 805px;
          &::before {
            bottom: 22px;
            left: -21px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -26px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-8 {
          top: 177px;
          left: 675px;
          &::before {
            bottom: -25px;
            left: -22px;
            width: 70px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -59px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-6 {
          top: 177px;
          left: 570px;
          &::before {
            bottom: -25px;
            left: -32px;
            width: 70px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -59px;
            left: -18px;
          }
          .state-info {
            right: 33px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-4 {
          top: 158px;
          left: 440px;
          &::before {
            bottom: 22px;
            left: -2px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -170px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-2 {
          top: 135px;
          left: 350px;
          &::before {
            bottom: 45px;
            left: -30px;
            width: 90px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 89px;
            left: 23px;
          }
          .state-info {
            right: -165px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-4 {
          top: 132px;
          left: 240px;
          &::before {
            bottom: 38px;
            left: -33px;
            width: 70px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 73px;
            left: -19px;
          }
          .state-info {
            right: 34px;
            top: -58px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-2 {
          top: 168px;
          left: 145px;
          &::before {
            bottom: 22px;
            left: -20px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -25px;
          }
          .state-info {
            right: 35px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .station-block-left {
          top: 108px;
          left: 282px;
        }

        .sta-left {
          top: 108px;
          left: 282px;
          &::before {
            bottom: 15px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -73px;
            top: -76px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .station-block-right {
          top: 108px;
          left: 945px;
        }

        .sta-right {
          top: 108px;
          left: 945px;
          &::before {
            bottom: 15px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -70px;
            top: -76px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 115px;
          }
        }
      }
    }
  }

  .drain-container {
    display: flex;
    justify-content: flex-end;
  }

  .valve-sign {
    margin-top: auto;
    margin-bottom: auto;
    width: 12px;
    height: 12px;
    background-color: #ffff00;
    animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
    border-radius: 10px;
    margin-left: 12px;

    &.running {
      background-color: #67dd34;
      animation: none;
    }
    &.stopped {
      background-color: #a0a0a0;
      animation: none;
    }
  }
}
</style>